import React, { useEffect, useState } from "react"
import clsx from "clsx"
import { Course } from "@interfaces/course/course"
import { Category } from "@interfaces/course/category"
import { useCategories } from "@lib/api/hooks/useCategories"
import { container, Container, FlexBox } from "@components/wrapper"
import { Skeleton } from "@components/misc"
import { ClassCard, LoadingClassCard } from "@components/card"
import { BasicLink, Heading } from "@components/typography"
import { isMobile } from "react-device-detect"
import CourseListServices from "@services/course-list.services"

export const AllClassColumn = () => {
  const [isCourseLoading, setIsCourseLoading] = useState(true)
  const [activeCategory, setActiveCategory] = useState("")

  const [course, setCourse] = useState<Course[]>([])

  const classList = new CourseListServices()

  const { data: categories, isLoading: isCategoryLoading } = useCategories()

  useEffect(() => {
    const getCourse = async () => {
      try {
        setIsCourseLoading(true)
        const courseList = await classList.getCourseList({
          limit: 8,
          page: 1,
          category: activeCategory,
        })

        if (courseList.isSuccess) {
          setCourse(courseList.getValue().data)
          setIsCourseLoading(false)
        } else {
          setIsCourseLoading(false)
        }
      } catch (e) {
        setIsCourseLoading(false)
      }
    }

    if (categories.length && !activeCategory) {
      setActiveCategory(categories[0].category_slug)
    }

    if (categories.length && activeCategory) {
      getCourse()
    }
  }, [activeCategory, categories])

  const buttonClass =
    "sm:w-1/5 w-[140px] text-sm sm:text-base text-center font-semibold rounded border-2 sm:py-3 py-2"

  const handleSelect = (data: Category) => () => {
    setActiveCategory(data.category_slug)
  }

  const Component = () => {
    if (!isCategoryLoading && !categories.length) {
      return <></>
    }

    return (
      <FlexBox direction="col" className="sm:gap-10 gap-9">
        <FlexBox className={clsx("sm:gap-8 gap-2", isMobile ? "slider-row px-4" : container)}>
          {/* When category is loading */}
          {isCategoryLoading
            ? [1, 2, 3, 4, 5].map((value) => (
                <FlexBox key={value} className="w-full">
                  <Skeleton sizes={clsx("h-12 sm:w-full", "w-[140px]")} />
                </FlexBox>
              ))
            : categories.slice(0, 4).map((item, i) => (
                <button
                  key={i}
                  className={clsx(
                    buttonClass,
                    activeCategory === item.category_slug
                      ? "text-white bg-green border-green"
                      : "bg-transparent text-grey-97 border-2 border-grey-ec",
                    "flex-none sm:flex-1"
                  )}
                  onClick={handleSelect(item)}
                >
                  {item.category_name}
                </button>
              ))}

          <BasicLink
            href={"/category"}
            className={clsx(buttonClass, "text-grey-97 border-grey-ec flex-none sm:flex-1")}
          >
            Lihat Semua Kelas
          </BasicLink>
        </FlexBox>

        <div className={clsx(isMobile ? "slider-row px-4" : container, "sm:mb-16")}>
          <FlexBox className={clsx("sm:w-full sm:flex-wrap sm:gap-[2vw]", "w-fit gap-[4vw]")}>
            {/* When course is loading */}
            {isCourseLoading &&
              [1, 2, 3, 4].map((value) => (
                <LoadingClassCard
                  key={value}
                  className={clsx("sm:w-[calc(25.5%-2vw)]", "w-[65vw]")}
                />
              ))}

            {course?.map((value, index) => (
              <ClassCard data={value} key={index} className="w-[65vw] sm:w-[calc(25.5%-2vw)]" />
            ))}
          </FlexBox>
        </div>
      </FlexBox>
    )
  }

  if (!isCategoryLoading && !categories.length) {
    return <></>
  }

  return (
    <section className={clsx("sm:py-[50px] relative", "py-[30px]")}>
      <Container>
        <Heading headingLevel="h2" className="sm:mb-10 mb-8">
          Temukan Apa Yang Menarik Untuk Kamu Pelajari
        </Heading>
      </Container>

      <Component />
    </section>
  )
}
